<div class="window" cdkDrag>
  <div class="header" cdkDragHandle>
    <h4>Running Tasks</h4>
    <sui-button
      size="sm"
      variant="ghost"
      [leadingIcon]="['fas', 'times']"
      [iconOnly]="true"
      ariaLabel="Close"
      (click)="close()"
    ></sui-button>
  </div>
  <div class="tasks">
    <div class="task" *ngFor="let task of userBackgroundTasks">
      {{ task.id }} {{ task.progress }} {{ task.algorithm_name }}
      <sui-progress
        class="mb-3"
        variant="success"
        [value]="task.progress"
        [max]="task.total"
      />
    </div>
  </div>
</div>
